import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';

interface RemoveModalTypes {
	index: number;
	removeHandler: (index: number) => void;
	closeModal?: closeModalType;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({ index, removeHandler, closeModal }) => {
	const confirmRemove = () => {
		removeHandler(index);

		if (closeModal) {
			closeModal();
		}
	};

	return (
		<div className="modal-confirmation">
			<figure className="icon">
				<AlertIcon />
			</figure>

			<h2 className="heading h4">Are you sure you wish to remove this Checklist item?</h2>

			<section className="actions">
				<Button className="btn-primary full-width" onClick={confirmRemove}>
					Yes
				</Button>

				<Button className="btn-secondary full-width" onClick={closeModal}>
					Cancel
				</Button>
			</section>
		</div>
	);
};

export default RemoveModal;
